var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "title": "Form Persetujuan Retur",
      "id": "supplier-modal",
      "size": "md",
      "no-close-on-backdrop": "",
      "no-close-on-esc": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function () {
        return [_c('b-button', {
          attrs: {
            "variant": "primary"
          },
          on: {
            "click": function ($event) {
              $event.preventDefault();
              return _vm.submit($event);
            }
          }
        }, [_vm._v("Setujui")])];
      },
      proxy: true
    }])
  }, [_c('b-form-group', {
    attrs: {
      "label": "Pilih Supplier"
    }
  }, [_c('v-select', {
    attrs: {
      "options": _vm.supplierOptions,
      "label": "text",
      "reduce": function (option) {
        return option.value;
      }
    },
    model: {
      value: _vm.supplier_id,
      callback: function ($$v) {
        _vm.supplier_id = $$v;
      },
      expression: "supplier_id"
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }